/**
 * Aviva white-label theme tokens.
 *
 * Sources:
 * - docs/aviva/branding-colour/ (Brand expression principles — March 2025)
 * - https://www.aviva.co.uk/ (UK consumer — CTAs, navy chrome, yellow accents)
 * - https://www.aviva.com/ (ION fusion / corporate CSS)
 * Official kits: https://www.avivabrand.com/
 *
 * Mapped in src/styles/aviva/ (index + buttons).
 */
export default {
  id: 'aviva',
  displayName: 'Aviva',
  /** Primary mailbox for Aviva ContinuityCoach inbound/outbound contact. */
  contactEmail: 'ARMSContinuity@aviva.com',
  fonts: {
    // Single quotes so values stay valid inside HTML style="..." attributes for PDF export
    family: "'Source Sans 3', 'Source Sans Pro', Roboto, 'Helvetica Neue', Arial, sans-serif",
    displayFamily: "'Aviva Curve', 'Source Sans 3', Roboto, 'Helvetica Neue', Arial, sans-serif",
  },
  colors: {
    // Brand — March 2025 palette (docs/aviva/branding-colour)
    brandPrimary: '#FFD900', // Aviva yellow (do not tint for palette steps)
    brandPrimaryHover: '#FFE663', // UI-only hover (not an official yellow tint)
    brandPrimaryActive: '#FFC900', // UI-only active
    brandSecondary: '#1C4FD2', // Bright blue — links / actions
    brandSecondaryHover: '#191D64', // Dark blue on hover (accessible brand pair)
    brandNavy: '#191D64', // Dark blue — logo, chrome, strong borders
    brandOnPrimary: '#191D64', // text/icons on yellow
    brandAccent: '#00596B', // Teal
    brandAccentLight: '#37AFBA', // Light teal — icons / outlines
    brandSuccess: '#002B1F', // Dark green
    brandFocusRing: '#FFD900',

    // Surfaces
    surface: '#FFFFFF',
    surfaceMuted: '#EEEFEE', // Light grey 50%
    appBg: '#F7F7F7', // Light grey 25%
    chromeNavy: '#191D64',

    // Text
    textStrong: '#191919', // Charcoal
    textBody: '#333333', // App body (readable mid charcoal; not on palette sheet)
    textMuted: '#535353', // Charcoal 75%

    // Borders
    borderSoft: '#EEEFEE', // Light grey 50%
  },
  // Shape tokens consumed as CSS vars where useful
  radii: {
    control: '8px',
    button: '999px', // pill — aviva.co.uk CTA shape
    card: '12px',
  },
};
